import { combineReducers } from "redux";

import mainMenu from "app/@Base/components/AppMenu/store/reducers/index";
import mainNavBar from "app/@Base/components/NavBar/store/reducers/index";
import SecondaryNavBar  from "app/@Base/components/SecondaryNavBar/store/reducers/index";
import certificaciones from "app/@Base/components/BannerCert/store/reducers/index";
import banner from "app/@Base/components/BannerHero/store/reducers/index";
import footer from "app/@Base/components/Footer/store/reducers/index";
import findBar from "app/@Base/components/FindBar/store/reducers/index";

import Base from "app/@Base/store/reducers/index";

import AhorroYCredito from "app/@Content/components/AhorroYCredito/store/reducers/index";

const createReducer = (asyncReducers) =>
  combineReducers({    
    Base,    
    mainMenu,
    findBar,
    mainNavBar,
    SecondaryNavBar,
    banner,
    certificaciones,
    footer,
    AhorroYCredito,
    ...asyncReducers
  });
export default createReducer  